import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import ClusterSearchForm from './search-form.js'

const ClusterSearchModel = {
  descricao: null
}

export default {
  mixins: [ActionsForm],
  name: 'ClusterSearch',
  data () {
    return {
      data: ClusterSearchModel,
      form: ClusterSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/regional/components/search/search.js